import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from 'primereact/button';
import { API, DataStore, graphqlOperation } from 'aws-amplify';
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { toast } from "react-toastify";
import { graphQLFindRecordById } from "../../helper/commonfunctions";
import { StipendMaster } from "../../models";

const ReportDeleteDialog = (props) => {


  console.log("props", props);

  // const {data} = props;

  const handleDeleteRow = async requestedId => {

    try {

      console.log("requestedId", requestedId);
      if (props.tableName == "getStipendMaster") {
        const original = await DataStore.query(StipendMaster, requestedId);
// console.log('✌️original --->', original);
        await DataStore.save(
          StipendMaster.copyOf(original, (updated) => {
            updated.isSoftDelete = true;
          })
        )
      } else {
        let original = await graphQLFindRecordById(props.tableName, requestedId)

        await API.graphql(
          graphqlOperation(props.mutations, {
            input: {
              id: original.id,
              isSoftDelete: "True",
              _version: original?._version
            }
          })
        );
      }
      toast.success('Request Deleted Successfully.');
      props.setIsLoadData();
      props.getMasterData();

    } catch (err) {
      console.log("Error is Delete :-", err);
    }
  };




  const footerContentForDeleteForm = () => (
    <div className="text-center">
      <>
        <button
          className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#113699] border border-[#EFF8FF] rounded-md"
          onClick={() => {
            handleDeleteRow(props.isVisibleDeleteID);
            props.setIsVisibleDelete(false);
          }}
        >
          OK
        </button>
        <button
          onClick={() => {
            props.setIsVisibleDelete(false);
          }}
          type="button"
          className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
          id="add-family-cancel-btn"
        >
          Cancel
        </button>

      </>
    </div>
  );



  return (
    <>
      <Dialog
        header="Delete Requested Form"
        visible={props.isVisibleDelete}
        style={{ width: "30vw" }}
        //                      closable={false}
        onHide={() => {
          props.setIsVisibleDelete(false);
        }}
        footer={footerContentForDeleteForm}
      >
        <div className="m-0">
          <div className="font-medium text-[18px] text-[#249144]">
            Are you sure you want to delete the record? The deleted record will not be available for future
            reference and will be deleted from everyone’s queue in the workflow.
          </div>
        </div>
      </Dialog>
    </>
  )

}

export default ReportDeleteDialog
